import { ExpandMore } from "@mui/icons-material";
import { Collapse, Grid, TableCell, TableRow } from "@mui/material";
import Tooltip from "../../../Atoms/Tooltip";
import { useState } from "react";
import { formatDocument } from "../../../../Utils/formatters";
import {
  CollapseContainer,
  CollapseContent,
  CustomTableRow,
  ExpandMoreButton,
  StyledH2,
} from "../styles";

interface RowProps {
  item: any;
}

export const InvoiceRowBuyer = ({ item }: RowProps) => {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => setExpanded(!expanded);

  const checkIfValueIsNull = (value: string | null | undefined) => {
    return value ?? "-";
  };

  return (
    <>
      <CustomTableRow>
        <TableCell>
          <ExpandMoreButton
            expand={expanded}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="Mostrar detalhes do comprador"
            title="Mostrar detalhes do comprador"
          >
            <ExpandMore />
          </ExpandMoreButton>
        </TableCell>

        {/* cnpf */}
        <TableCell>{formatDocument(
          item.national_Registration,
          item.national_Registration && item.national_Registration.length > 11
            ? "CNPJ_COMPACT"
            : "CPF"
        )}</TableCell>

        {/* nome */}
        <TableCell>{checkIfValueIsNull(item.trade_Name)}</TableCell>

        {/* IE */}
        <TableCell>{checkIfValueIsNull(item.ie)}</TableCell>

        {/* email */}
        <TableCell>{checkIfValueIsNull(item.email)}</TableCell>
      </CustomTableRow>
      <TableRow>
        <TableCell colSpan={9} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CollapseContainer>
              <StyledH2>Detalhes</StyledH2>
              <CollapseContent>
                <Grid container spacing={2}>
                  <Grid item xs={10} sm={4} md={3}>
                    <p>
                      <strong>Endereço:</strong>{" "}
                      <Tooltip title={checkIfValueIsNull(item?.address)}>
                        <span
                          style={{
                            display: "block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {checkIfValueIsNull(item?.address)}
                        </span>
                      </Tooltip>
                    </p>
                  </Grid>
                  <Grid item xs={5} sm={2} md={2}>
                    <p>
                      <strong>Número:</strong>{" "}
                      <span>{checkIfValueIsNull(item?.number)}</span>
                    </p>
                  </Grid>
                  <Grid item xs={7} sm={4} md={3}>
                    <p>
                      <strong>Bairro:</strong>{" "}
                      <Tooltip title={checkIfValueIsNull(item?.district)}>
                        <span
                          style={{
                            display: "block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {checkIfValueIsNull(item?.district)}
                        </span>
                      </Tooltip>
                    </p>
                  </Grid>
                  <Grid item xs={6} sm={3} md={2}>
                    <p>
                      <strong>CEP:</strong>{" "}
                      <span>{checkIfValueIsNull(item?.postal_Code)}</span>
                    </p>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <p>
                      <strong>Complemento:</strong>{" "}
                      <Tooltip title={checkIfValueIsNull(item?.complement)}>
                        <span
                          style={{
                            display: "block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "100%",
                          }}
                        >
                          {checkIfValueIsNull(item?.complement)}
                        </span>
                      </Tooltip>
                    </p>
                  </Grid>
                </Grid>
              </CollapseContent>
            </CollapseContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
